export default __webpack_public_path__ + "static/media/team3.c4d304ac.jpg";